import React__default from 'react';

const HeadingLevelContext = React__default.createContext({
  level: 1
});
const useHeadingLevel = () => React__default.useContext(HeadingLevelContext);
const HeadingLevelProvider = ({ level = 1, children }) => {
  return React__default.createElement(HeadingLevelContext.Provider, { value: {
    level
  } }, children);
};

export { HeadingLevelProvider, useHeadingLevel };
//# sourceMappingURL=HeadingLevelContext.es.js.map
